import React from 'react';
import { HelpArticleLinkContext, HelpArticleLinkTextContext } from 'components/Router/Router';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';

import Typography from '@material-ui/core/Typography';
import HelpArticleLink from 'components/Page/HelpArticleLink';

interface Props {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

function PageTitle({ title, subtitle, actions, className }: Props) {
  const classes = useStyles();
  const helpArticleLink = React.useContext(HelpArticleLinkContext) as string | null;
  const helpArticleLinkText = React.useContext(HelpArticleLinkTextContext) as string | null;

  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.content}>
        <Typography variant="h4" className={classes.title} data-cy="page-title--title">
          {title}
        </Typography>
        {subtitle && (
          <Typography
            variant="subtitle2"
            className={classNames({
              [classes.helpLinkSpacing]: !!helpArticleLink,
            })}
          >
            {subtitle}
          </Typography>
        )}
        {helpArticleLink && <HelpArticleLink link={helpArticleLink} text={helpArticleLinkText} />}
      </div>
      {actions && <div className={classes.actions}>{actions}</div>}
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
    display: 'flex',
  },
  content: {
    flex: '1 1 auto',
  },
  title: {
    fontSize: 26,
    fontWeight: 700,
    marginTop: 10,
    marginBottom: 10,
    marginRight: theme.spacing(2),
  },
  helpLinkSpacing: {
    marginBottom: theme.spacing(1),
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
  },
}));

export default PageTitle;
